import * as styledComponents from 'styled-components';
import { defaultTheme } from './theme';
var _a = styledComponents, styled = _a.default, css = _a.css, createGlobalStyle = _a.createGlobalStyle, keyframes = _a.keyframes, ThemeProvider = _a.ThemeProvider, withTheme = _a.withTheme;
export { css, createGlobalStyle, keyframes, ThemeProvider, defaultTheme, withTheme, };
export default styled;
